import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'

export interface IFilterObject {
  title: string
  value: string
  checked: boolean
  section: boolean
  subTypes?: IFilterObject[]
}

export interface IFilterComponent {
  filterObject: IFilterObject[]
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  presets: IPreset[]
  onChangePresetHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export interface IPreset {
  id: number
  name: string
  values: string[]
  checked: boolean
}

const FilterComponent: React.FC<IFilterComponent> = ({
  filterObject,
  onChangeHandler,
  onChangePresetHandler,
  presets,
}) => {
  const renderFilters = (testObject: IFilterObject[], level: number) => {
    return testObject?.map(filter => {
      if (!filter?.subTypes) {
        return (
          <Box key={filter?.value}>
            <FormControlLabel
              control={<Checkbox value={filter.value} onChange={onChangeHandler} />}
              checked={filter?.checked}
              label={
                <Typography
                  {...(level == 1 ? { variant: 'bodyBold' } : { variant: 'bodyRegular' })}
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  {filter?.title}
                </Typography>
              }
            />
          </Box>
        )
      }

      return (
        <Box key={filter?.value} sx={{ paddingX: '1rem' }}>
          <Typography {...(level == 1 ? { variant: 'bodyBold' } : { variant: 'bodyRegular' })}>
            {filter?.title}
          </Typography>
          {filter?.subTypes && <Box>{renderFilters(filter?.subTypes, level + 1)}</Box>}
        </Box>
      )
    })
  }

  const renderPresets = () => {
    return presets.map(preset => {
      return (
        <Box key={preset?.name}>
          <FormControlLabel
            control={<Checkbox value={String(preset.id)} onChange={onChangePresetHandler} />}
            checked={preset?.checked}
            label={<Typography variant='bodyRegular'>{preset.name}</Typography>}
          />
        </Box>
      )
    })
  }
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        maxHeight: '80vh',
        overflow: 'visible',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          borderRight: '1px solid #ccc',
        },
      }}
    >
      {renderFilters(filterObject, 1)}
      {presets?.length > 0 && (
        <Box sx={{ px: '1rem' }}>
          <Typography variant={'bodyBold'}>Presets</Typography>
          {renderPresets()}
        </Box>
      )}
    </Box>
  )
}

export default FilterComponent
